<template>
  <span>
    <template v-if="item.type === 'allocated'">
      <v-text-field
        class="mr-2"
        v-model="item.distribution_key"
        :placeholder="$t('cost-allocators.distribution-key')"
        :rules="[
          rules.required,
          rules.number({ min: 0 }),
          backEndValidation('distribution_key')
        ]"
      ></v-text-field>
      <v-combobox
        :items="symbols.map(i => i.symbol)"
        v-on:update:search-input="val => (distributionKeyUnit = val)"
        v-model="distributionKeyUnit"
        :placeholder="$t('cost-allocators.distribution-key-unit')"
        :rules="[rules.required, backEndValidation('distribution_key_unit')]"
        ref="distributionKeyUnit"
      ></v-combobox>
    </template>
    <template v-else>
      <TreeSelector
        :placeholder="$t('cost-allocators.countable')"
        v-model="item.consumption_metering"
        :items="meterUnits"
        :rules="[rules.required, backEndValidation('consumption_metering')]"
        :options-for-tree-items="{
          groupKey: '_groups',
          canChooseGroup: false
        }"
      ></TreeSelector>
    </template>
  </span>
</template>
<script>
import { rules } from "../../../mixins/rules";
import TreeSelector from "../../inputs/TreeSelector";
export default {
  name: "CalculationBaseFormItem",
  components: {
    TreeSelector
  },
  data: () => ({
    group_id: ""
  }),
  props: {
    slotData: {
      type: Object
    },
    item: {
      type: Object
    }
  },
  mixins: [rules],
  computed: {
    meterUnits() {
      let items = [];
      this.$store.getters["projectMeteringStore/meterUnitStore/getList"].map(
        mu => {
          let meterName = mu._meter ? mu._meter.name : "Without meter";
          if (this.item.type !== "allocated")
            items.push({
              name: `${mu.name}`,
              id: `${mu.id}`,
              icon: "mdi-google-analytics",
              disabled: this.item.type === "allocated",
              alwaysActive: this.item.type !== "allocated",
              _groups:
                mu._meter && mu._meter._group
                  ? [
                      ...(mu._meter._group._ancestors || []),
                      mu._meter._group,
                      {
                        name: meterName,
                        serial_number: mu._meter.serial_number,
                        id: `${mu.id}_meter_${mu._meter.id}`
                      }
                    ]
                  : []
            });
        }
      );
      return items;
    },
    symbols() {
      return this.$store.getters["presetStore/getSymbolPreset"];
    },
    distributionKeyUnit: {
      get() {
        return this.item.distribution_key_unit || "";
      },
      set(val) {
        this.$set(this.item, "distribution_key_unit", val);
      }
    }
  },
  watch: {
    item() {
      if (
        this.item &&
        this.item._meter_unit &&
        this.item._meter_unit._meter &&
        this.item._meter_unit._meter._group
      ) {
        this.group_id = this.item._meter_unit._meter._group.id;
      }
    },
    costAllocator() {
      if (
        this.costAllocator &&
        this.costAllocator._meter_unit &&
        this.costAllocator._meter_unit._meter
      ) {
        this.$store.dispatch("projectMeteringStore/meterStore/get", {
          id: this.costAllocator._meter_unit._meter.id,
          project_id: this.$route.params.project_id,
          onSuccess: res => {
            if (res._groups && res._groups.length > 0) {
              this.group_id = res._groups[res._groups.length - 1];
            }
          }
        });
      }
    }
  },
  mounted() {
    if (
      this.item &&
      this.item._meter_unit &&
      this.item._meter_unit._meter &&
      this.item._meter_unit._meter._group
    ) {
      this.group_id = this.item._meter_unit._meter._group.id;
    }
  }
};
</script>

<style scoped>
span {
  display: flex;
}
</style>
